import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1024_65611)\"><path d=\"M60 0H0V60H60V0Z\" fill=\"#F6E4B2\"></path><path d=\"M49.3332 14.0027C43.9976 8.66707 35.3371 8.66707 30.0015 14.0027C24.6658 8.66707 16.0115 8.66707 10.6697 14.0027C5.33406 19.3383 5.33406 27.9927 10.6697 33.3345L30.0015 52.6662L49.3332 33.3345C54.6689 27.9988 54.6689 19.3445 49.3332 14.0027Z\" fill=\"#9C5B23\"></path></g><defs><clipPath id=\"clip0_1024_65611\"><rect width=\"60\" height=\"60\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }